var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "collection-management" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "收款列表", name: "1" } }),
          _c("el-tab-pane", { attrs: { label: "确认单列表", name: "2" } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tab-content" },
        [
          _vm.activeTab === "2"
            ? _c("myColletionOrder", { ref: "myColletionOrder" })
            : _c("totalCollectionOrderList", {
                ref: "totalCollectionOrderList",
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }